import { Link, navigate } from 'gatsby-plugin-intl';
import { default as React } from 'react';
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet,
  PoweredBy,
} from 'react-instantsearch-dom';
const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits;
  return hitCount > 0 ? (
    <div className="HitCount">
      {hitCount} result{hitCount !== 1 ? `s` : ``}
    </div>
  ) : null;
});
const PageHit = ({ hit }) => {
  return (
    <div className="mb-2 rounded bg-yellow-400 px-2 py-1">
      <h4 onClick={() => navigate(hit.url)}>
        <Highlight
          attribute="title"
          hit={hit}
          tagName="mark"
          className="bg-green-400"
        />
      </h4>
      <Snippet attribute="excerpt" hit={hit} tagName="mark" />
    </div>
  );
};
const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    {/* <HitCount /> */}
    <Hits hitComponent={PageHit} className="Hits  " />
  </Index>
);
const SearchResult = ({ indices, className }) => (
  <div className={className}>
    {indices.map((index) => (
      <HitsInIndex index={index} key={index.name} />
    ))}

    {/* <PoweredBy className="h-4 bg-red-300" /> */}
  </div>
);
export default SearchResult;
